import React from "react";
import { Triangle } from "react-loader-spinner";

export default function Preloader(props) {
  return (
    <div className={props.className}>
      <div className="holder">
        <Triangle
          visible={true}
          height="80"
          width="80"
          color="#000"
          ariaLabel="triangle-loading"
          wrapperStyle={{}}
          wrapperClass=""
        />
      </div>
    </div>
  );
}
